/** NIMSI Clinic — цвета из логотипа (глубокий синий #01416d). */
export const BRAND = {
  navy: '#01416d',
  navyDark: '#013256',
  navyDarker: '#01213c',
  navyLight: '#1a628f',
  /** Акцент вместо мятного DEM: светлее логотипа, из той же гаммы. */
  green: '#2b8bc4',
  greenLight: '#5aadd8',
  greenDark: '#1a6fa3',
  greenMuted: '#e6f2f8',
  greenSoft: '#cde4f0',
};

export const BRAND_SCALE = {
  100: BRAND.greenMuted,
  200: '#b8d9eb',
  300: '#7ebfdc',
  400: BRAND.greenLight,
  500: BRAND.green,
  600: BRAND.greenDark,
  700: BRAND.navy,
  800: BRAND.navyDark,
  900: BRAND.navyDarker,
};

export const BRAND_CHART_PALETTE = [
  BRAND.navy,
  BRAND.green,
  BRAND.navyLight,
  BRAND.greenLight,
  '#7ebfdc',
];

export const GRADIENT_GREEN = `linear-gradient(135deg, ${BRAND.green} 0%, ${BRAND.greenDark} 100%)`;
export const GRADIENT_NAVY = `linear-gradient(135deg, ${BRAND.navy} 0%, ${BRAND.navyDark} 100%)`;
export const GRADIENT_NAVY_GREEN = `linear-gradient(135deg, ${BRAND.navy} 0%, ${BRAND.green} 100%)`;
export const GRADIENT_SOFT = `linear-gradient(135deg, ${BRAND.navyLight} 0%, ${BRAND.green} 100%)`;
export const GRADIENT_AMBER = `linear-gradient(135deg, #e8a838 0%, #d4881c 100%)`;

export const CHART_AXIS = '#7a8ba8';
export const CHART_GRID = 'rgba(1, 65, 109, 0.12)';

export function hexAlpha(hex, alpha) {
  const h = hex.replace('#', '');
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function apexBarFill(colorFrom, fadeAlpha = 0.28) {
  return {
    type: 'gradient',
    gradient: {
      type: 'vertical',
      shadeIntensity: 1,
      opacityFrom: 0.88,
      opacityTo: 0.95,
      colorStops: [
        [{ offset: 0, color: colorFrom, opacity: 1 }],
        [{ offset: 100, color: hexAlpha(colorFrom, fadeAlpha), opacity: 1 }],
      ],
    },
  };
}

export const apexGrid = {
  show: true,
  borderColor: CHART_GRID,
  yaxis: { lines: { show: false } },
  xaxis: { lines: { show: false } },
};

export const apexXaxisLabels = {
  style: { colors: CHART_AXIS, fontSize: '12px', fontWeight: '500' },
  axisBorder: { show: false },
  axisTicks: { show: false },
};
